<template>
    <v-app id="inspire">
        <v-card class="mx-auto" max-width="100%">
            <v-container>
                <v-row dense>
                    <v-col cols="12">
                        <v-card color="#385F73" dark>
                            <v-card-title class="headline">
                                Misión:
                            </v-card-title>

                            <v-card-text>
                                <p>
                                    * Desarrollar, planificar, coordinar, ejecutar y controlar todas las tareas
                                    relacionadas
                                    con los proyectos de obras y servicios y puestas en marcha, dando plena satisfacción
                                    a
                                    los requerimientos del cliente mediante soluciones integradoras, optimizando costos
                                    tanto en recursos humanos como materiales y tecnológicos.
                                </p>
                                <p>
                                    * Dar apoyo técnico a otros sectores de la empresa, ya sea colaborando con la
                                    presupuestación o mediante la elaboración de estándares para la ejecución de obras y
                                    servicios, como así también capacitación para el crecimiento profesional de sus
                                    integrantes.
                                </p>
                                <p>
                                    * Participar en la búsqueda de nuevos desarrollos, métodos, productos y equipos para
                                    mejorar la competitividad y eficiencia, acorde a los requerimientos del mercado.
                                </p>
                                <p>
                                    * Mantener vigente un sistema de resguardo de documentación e información asociada
                                    (archivo) correspondiente a las provisiones, fabricación, obras y servicios.
                                    Mantener
                                    ordenado el archivo general de la empresa.
                                </p>
                                <p>
                                    * Desarrollar todas las tareas, observando las normas de calidad, cuidado del medio
                                    ambiente, y seguridad y salud ocupacional, cumplimentando nuestro SGI.
                                </p>
                                <p>
                                    * Colaborar con el departamento abastecimiento en la sub-contratación de empresas
                                    calificadas para locación de obras, capacitarlos en el SGI y suministrarles toda la
                                    información necesaria para la correcta realización de los trabajos y sus controles.
                                </p>
                            </v-card-text>
                        </v-card>
                    </v-col>
                </v-row>
            </v-container>
            <v-container>
                <v-row dense>
                    <v-col v-for="(item, i) in listado" :key="i" cols="12" md="6" lg="4">
                        <v-card :color="colorCumplimiento(item.valoractual)">
                            <v-card-title>Objetivo: {{ item.codgral }}</v-card-title>

                            <v-card-text>
                                <div><strong>Descr.:</strong> {{ item.objetivo }}</div>
                                <div><strong>Tipo:</strong> {{ item.tipo }}</div>

                                <div>
                                    <strong>Meta:</strong>
                                    <pre class="meta">{{ item.meta }}</pre>
                                </div>

                                <div><strong>Indicador:</strong> {{ item.indicador }}</div>
                                <div><strong>Responsable:</strong> {{ item.responsable }}</div>
                                <div><strong>Cumplimiento:</strong> {{ item.cumplimiento }}%</div>
                                <div><strong>Valor Indic / Referencia:</strong> {{ item.valoractual }} / {{
                                    item.referencia }}</div>
                                <div><strong>Plan:</strong> {{ item.plan }}</div>
                                <div><strong>Observaciones:</strong> {{ item.observ }}</div>

                                <div>
                                    <strong>Fecha de Actualización:</strong>
                                    {{ item.fecha }}
                                </div>
                            </v-card-text>
                        </v-card>
                    </v-col>
                </v-row>
            </v-container>
        </v-card>
    </v-app>
</template>
<style>
.meta {
    white-space: pre-wrap;
    /* ← Para permitir varias líneas */
    font-family: inherit;
}
</style>
<script>
import moment from "moment";
import axios from "../../axios-auth.js";
export default {
    data: () => ({
        usuario: null,
        now: moment(),
        diferencia: "",
        listado: [],
    }),
    watch: {},
    created() {
        this.usuario = this.$store.state.usuario.toString().trim();
        this.cargarListado();
    },
    mounted() {
        if (this.$store.state.usuario == "" || this.$store.state.usuario == null) {
            this.$store.dispatch("logout");
        } else {
            this.$store.state.sector = "Ingenieria";
            //  this.cargaraccidentes();
        }
    },
    methods: {
        colorCumplimiento(item) {
            if (item != null && item != "") {
                if (item == "0") {
                    return "red";
                }
                if (item == "100") {
                    return "green";

                }
                if (item.replace(",", ".") > 0 && item.replace(",", ".") < 100) {
                    return "yellow";
                }
            }
        },

        cargarListado() {
            this.loadtable = true;
            const codgral = "";
            const periodo = "";
            const objetivo = "";
            const meta = "";
            const indicador = "";
            const responsable = "";
            const area = "Ingeniería de Obra";
            const tipo = "";
            const asociado = "";

            let self = this;
            axios
                .get("/Indicadores/ListadoObjetivos?", {
                    params: {
                        codgral: codgral,
                        periodo: periodo,
                        objetivo: objetivo,
                        indicador: indicador,
                        responsable: responsable,
                        meta: meta,
                        asociado: asociado,
                        area: area,
                        tipo: tipo,

                    },
                })
                .then((response) => {
                    self.listado = response.data;
                    self.loadtable = false;
                    console.log(self.listado)
                })
                .catch((error) => {
                    self.listado = [];
                    console.log(error);
                });
        },
    },
};
</script>